// extracted by mini-css-extract-plugin
module.exports = {"navItem":"styles_navItem__7zJHU","activeItem":"styles_activeItem__iaMOY"};